module.exports = __webpack_public_path__ + "assets/img/block-right-hover-fcb1561d.png";